import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BookaCallState {
	count: number;
	setCount: (count: number) => void;
	incrementCount: () => void;
	resetCount: () => void;
}

export const useBookaCallStore = create<BookaCallState>()(
	persist(
		(set, get) => ({
			count: 0,
			
			setCount: (count: number) => {
				set({ count });
			},
			
			incrementCount: () => {
				const currentCount = get().count;
				set({ count: currentCount + 1 });
			},
			
			resetCount: () => {
				set({ count: 0 });
			},
		}),
		{
			name: 'booka-call-storage',
		}
	)
);
